import { inject } from '@angular/core';

import { ApolloLink, NextLink, Observable, Operation } from '@apollo/client/core';

import { TokenService } from '@hdms/shared/util-core';

import { HostContextService } from '../host-context/host-context.service';

/**
 * In standalone / SPA mode, the link delays incoming operation requests while waiting for TokenService being ready.
 * Else, in hostContext it will block requests completely if auth info is missing (immediate cloud-sso redirect expected).
 */
export function createReadyLink(): ApolloLink {
  const hostContext = inject(HostContextService);
  const ready$ = hostContext.context ? hostContext.ready$ : inject(TokenService).ready$;

  let ready = false;

  return new ApolloLink((operation: Operation, forward: NextLink) =>
    ready
      ? forward(operation)
      : new Observable(obs => {
          ready$.subscribe(() => {
            forward(operation).subscribe(obs);
            ready = true;
          });
        })
  );
}
